import { flexCenterSx } from '../../styles/Global.style';

export const footerContainerSx = {
  ...flexCenterSx,
  bottom: 0,
  width: '100%',
  maxWidth: '1100px',
  height: '60px',
  position: 'fixed',
};
